"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var serializePromises = exports.serializePromises = function serializePromises(fns) {
  return fns.reduce(function (promise, fn) {
    return promise.then(fn);
  }, Promise.resolve());
};